module.exports = __webpack_public_path__ + "static/media/xls-icon.d37912f4.svg";